import styled from 'styled-components';
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link, Route, Switch, Redirect } from 'react-router-dom';

import Nav from '../Nav';
import Image from '../Image';
import Button from '../Button';
import Account from './Account';
import Sites from './Sites/Sites';
import Popover from '../Popover';
import Admin from './Admin/Admin';
import UserPopover from './UserPopover';
import PrivateRoute from '../PrivateRoute';
import Dropdown, { ListItem } from '../Dropdown';
import {
    DashboardStc,
    MainNav,
    Container,
    NavLead,
    MenuBar,
    NavIcon,
    Line,
} from './Dashboard.stc';

import { getAuthUser } from '../../redux/selectors';

const UserThumb = styled(Image)`
    width: 40px;
    height: 40px;
    object-fit: cover;
`;

function Dashboard(props) {
    const { location, match } = props;
    const [toggle, setToggle] = useState(false);
    const authUser = useSelector(getAuthUser);
    const { path } = match;

    const isRouteWebsites = location.pathname.includes('dashboard/sites');

    useEffect(() => {
        (function () {
            var d = document;
            var s = d.createElement('script');
            var c = d.createElement('script');
            c.innerHTML = `
                var HW_config = {
                selector: "#dorik_hw_notification .button",
                account:  "Jr5MW7"
            }`;
            s.src = 'https://cdn.headwayapp.co/widget.js';
            s.async = 1;
            d.getElementsByTagName('head')[0].appendChild(s);
            d.getElementsByTagName('head')[0].appendChild(c);
        })();
    }, []);

    return (
        <DashboardStc>
            <MainNav>
                <Container className="container">
                    <div>
                        <NavLead>
                            <Link to="/">
                                <Image
                                    width="70"
                                    alt="Dorik.io Single Page Website Builder"
                                    src="https://assets.dorik.com/5e443dca5619780040289e37/images/one-color-png_(1)_wdk58cni.png"
                                />
                            </Link>
                        </NavLead>
                        <ul className="nav unstyle navbar--hide">
                            <li>
                                <NavLink to="/dashboard/sites">
                                    Websites
                                </NavLink>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://help.dorik.io"
                                >
                                    Documentation
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://go.10m.io/dorik-roadmap"
                                >
                                    Roadmap
                                </a>
                            </li>
                            <li>
                                <NavLink to="/dashboard/account/billing">
                                    Pricing
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="spread-between nav-list">
                        <ul className="nav unstyle navbar--hide">
                            <li>
                                <Link
                                    className="active"
                                    to={path + '/account/billing'}
                                >
                                    <FontAwesomeIcon
                                        fixedWidth
                                        icon={['fas', 'gift']}
                                    />{' '}
                                    Upgrade
                                </Link>{' '}
                            </li>
                        </ul>

                        {authUser && (
                            <Popover
                                placement="bottom"
                                className="mr-25"
                                content={<UserPopover user={authUser} />}
                            >
                                <UserThumb
                                    type="circle"
                                    src={
                                        authUser.avatar ||
                                        '/assets/images/user-thumb.png'
                                    }
                                />
                            </Popover>
                        )}
                        <Link to="/start">
                            <Button>+ New Website</Button>
                        </Link>
                    </div>
                    <MenuBar>
                        <Dropdown
                            placement="bottomRight"
                            content={
                                <>
                                    <ListItem>
                                        <NavLink to="/dashboard/sites">
                                            Websites
                                        </NavLink>
                                    </ListItem>
                                    <ListItem>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://help.dorik.io"
                                        >
                                            Documentation
                                        </a>
                                    </ListItem>
                                    <ListItem>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://go.10m.io/dorik-roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </ListItem>
                                    <ListItem>
                                        <NavLink to="/dashboard/account/billing">
                                            Pricing
                                        </NavLink>
                                    </ListItem>
                                </>
                            }
                        >
                            <NavIcon onClick={() => setToggle(!toggle)}>
                                <Line open={toggle} />
                                <Line open={toggle} />
                                <Line open={toggle} />
                            </NavIcon>
                        </Dropdown>
                    </MenuBar>
                </Container>
            </MainNav>
            {isRouteWebsites && (
                <Nav activeBorder>
                    <Container className="container">
                        <div>
                            <ul className="nav unstyle">
                                <li>
                                    <NavLink exact to="/dashboard/sites">
                                        All Websites
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/dashboard/sites/published">
                                        Published
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/dashboard/sites/unpublished">
                                        Unpublished
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </Container>
                </Nav>
            )}

            <Switch>
                <Redirect exact from="/dashboard" to="/dashboard/sites" />
                <Route path="/dashboard/sites/:status?" component={Sites} />
                <Route path="/dashboard/account" component={Account} />
                <PrivateRoute
                    path="/dashboard/admin"
                    component={Admin}
                    isAdminRoute
                />
            </Switch>

            <div id="dorik_hw_notification">
                <div className="button"></div>
                <div className="text">Updates</div>
            </div>
        </DashboardStc>
    );
}

export default React.memo(Dashboard);
